import { Redirect, RouteProps } from 'react-router-dom';
import React, { FC } from 'react';
import { useAtomValue } from 'jotai';
import { privateLoginStatus } from '@/state/privateAuth';
import { SentryRoute } from '@/sentry';
import routes from '@/components/private/routes';

export type UnauthenticatedRouteProps = RouteProps;

/**
 * A route which redirects to the private app if the current user is logged in.
 */
const UnauthenticatedRoute: FC<UnauthenticatedRouteProps> = (props) => {
  const loginStatus = useAtomValue(privateLoginStatus);

  if (loginStatus === 'LOGGED_IN') {
    return <Redirect to={routes.newAuthRequest} />;
  }

  return <SentryRoute {...props} />;
};

export default UnauthenticatedRoute;
